export const API_BASE_URL = location.protocol + '//fdcompute.com'
export const IMAGES_BASE_URL = location.protocol + '//fdcompute.com'
// export const API_BASE_URL = 'http://icloudsky.yunkannet.com'
// export const IMAGES_BASE_URL = 'http://icloudsky.yunkannet.com'